const mFeedSectionContentCardEditionDesignModal = {
  mFeedSectionContentCardEditionDesignModal: {
    fileExtensionError: {
      button: 'CERRAR',
      header: 'ERROR',
      section: 'Los formatos de archivo permitidos son: gif, jpg y png'
    }
  }
}

export default mFeedSectionContentCardEditionDesignModal
